export const moduleUser = {
    state: () => ({
        isLoggedIn: false,
        localnet: false,
        userdata: {},
        token: "",
        capabilities: [],
        definedCapabilities: [],
        capabilitiesLoaded: false,
    }),
    mutations: {
        resetIdentity(state) {
            state.isLoggedIn = false;
            state.localnet = false;
            state.userdata = {};
            state.token = "";
            state.capabilities = [];
            state.definedCapabilities = [];
            state.capabilitiesLoaded = false;
        },
        setIdentity(state, userdata) {
            state.userdata = userdata;
            state.token = userdata.token;
            state.localnet = Boolean(userdata.internal_ip);
            state.isLoggedIn = true;
            state.capabilities = [];
            state.definedCapabilities = [];
            state.capabilitiesLoaded = false;
        },
        userdata(state, userdata) {
            state.userdata = userdata;
        },
        isLoggedIn(state, isLoggedIn) {
            state.isLoggedIn = isLoggedIn;
        },
        localnet(state, localnet) {
            state.localnet = localnet;
        },
        token(state, token) {
            state.token = token;
        },
        setCapabilities(state, payload) {
            state.capabilities = payload.capabilities;
            state.definedCapabilities = payload.definedCapabilities;
            state.capabilitiesLoaded = true;
        },
    },
    actions: {},
    getters: {
        token: (state) => state.token,
        userdata: (state) => state.userdata,
        localnet: (state) => state.localnet,
        isLoggedIn: (state) => state.isLoggedIn,
        hasCapability: (state) => (key) => {
            return state.capabilities.includes(key);
        },
        isCapabilityDefined: (state) => (key) => state.definedCapabilities.includes(key),
        hasGroups: (state) => (perms) => {
            if (state.userdata.admin) {
                return true;
            }
            if (typeof perms === "string") {
                perms = [perms];
            }
            for (let perm of perms) {
                if (state.userdata.groups.includes(perm)) {
                    return true;
                }
            }
            return false;
        },
    },
};
